export const environment = {
  production: true,
  auth: {
    DOMAIN: 'docformative.auth0.com',
    CLIENT_ID: 'YAPjH7mBzGHRZaHiuDz39kuETd2QJNbF',
    AUDIENCE: 'https://docformative.com',
    LOGOUT_URL: 'https://docformative.com/logout',
  },
  backend: {
    url: 'https://docformative.com/core',
    videoUrl: 'https://docformative1.daily.co',
  },
};
